import React, {useState} from "react"
import {Resource} from "../../resources/common"
import {useResetScrollTop} from "../../hooks/useResetScrollTop"
import {DetailsList} from "../DetailsList/DetailsList"
import {Claims, useUserClaimsData} from "../../services/auth"
import {CheckDeposit} from "../../resources/checkDeposits"
import AssignmentCheckDepositDetails from "../AssignmentCheckDepositDetails/AssignmentCheckDepositDetails"
import Button from "../Button/Button"
import UpdateCheckDepositDetails from "../CheckDeposits/UpdateCheckDepositDetails"

interface AssignmentPageItemGeneralReviewCheckDepositDetailsProps {
	id: string
	checkDeposit?: CheckDeposit
	refresh: () => void
	refreshToken: number
	disabled?: boolean
	claims?: Claims
	included?: Resource[]
}

export function AssignmentPageItemGeneralReviewCheckDepositDetails({
	id,
	checkDeposit,
	refresh,
	refreshToken,
	disabled,
	claims,
	included,
}: AssignmentPageItemGeneralReviewCheckDepositDetailsProps) {
	const checkDepositDetailsContentRef = React.useRef<HTMLDivElement>(null)
	useResetScrollTop(checkDepositDetailsContentRef, [id])
	const userClaims = useUserClaimsData(claims)

	const [isEditMode, setIsEditMode] = useState(false)

	if (isEditMode) {
		return (
			<div className="edit-x9-container">
				{checkDeposit && (
					<UpdateCheckDepositDetails
						checkDepositId={checkDeposit.id}
						close={() => setIsEditMode(false)}
						refreshFunc={refresh}
						refreshToken={refreshToken}
						fieldClassName="field"
					/>
				)}
			</div>
		)
	}

	return (
		<DetailsList
			title="Check Details"
			icon="check-write--business-products"
			additionalHeaderContent={
				<Button variant="outline" size="normal" onClick={() => setIsEditMode(true)}>
					Edit for X9
				</Button>
			}
			contentRef={checkDepositDetailsContentRef}
			disabled={disabled}
			className="general-review-check-deposit"
		>
			{checkDeposit && (
				<div>
					<AssignmentCheckDepositDetails checkDeposit={checkDeposit} claims={userClaims} included={included} />
				</div>
			)}
		</DetailsList>
	)
}
